import { render, staticRenderFns } from "./RightSidePane.vue?vue&type=template&id=5b4c3684&scoped=true&"
import script from "./RightSidePane.vue?vue&type=script&lang=ts&"
export * from "./RightSidePane.vue?vue&type=script&lang=ts&"
import style0 from "./RightSidePane.vue?vue&type=style&index=0&id=5b4c3684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c3684",
  null
  
)

export default component.exports